import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=765c31c4&"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports